<script>
  export const params = {};
  import { api, pcd, apply, msg, messages, unitprice, ticketvalue, startdatenotice, confirmpageheader, confirmpageexplanation, quantityfield, addressinput, shopselect, applybtn, acceptbtn } from "../stores.js";
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import Modal from "../components/Modal.svelte";

  let loading = false;
  let alertmsg = "";
  let showModal = false;

  onMount(() => {
    window.scroll(0, 0);
    if (
      !$apply.email ||
      !$apply.lastname ||
      !$apply.firstname ||
      !$apply.lastnamekana ||
      !$apply.firstnamekana ||
      !$apply.zipcode ||
      !$apply.prefecture ||
      !$apply.city ||
      ($addressinput && !$apply.address) ||
      !$apply.tel ||
      !$apply.age ||
      !$apply.gender ||
      !$apply.quantity ||
      ($shopselect && !$apply.shopid)
    )
      push("/entry");
  });

  async function callApply(event) {
    if (loading) return;
    try {
      loading = true;
      const response = await fetch($api + "/apply", {
        mode: "cors",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pcd: $pcd,
          t: $apply.t,
          lastname: $apply.lastname,
          firstname: $apply.firstname,
          lastnamekana: $apply.lastnamekana,
          firstnamekana: $apply.firstnamekana,
          zipcode: $apply.zipcode,
          prefecture: $apply.prefecture,
          city: $apply.city,
          address: $apply.address,
          tel: $apply.tel,
          age: $apply.age,
          gender: $apply.gender,
          quantity: $apply.quantity,
          shopid: $apply.shopid,
          shopname: $apply.shopname,
          shopaddr: $apply.shopaddr,
          shoptel: $apply.shoptel
        }, (k,v) => v ? v : undefined),
      });
      const data = await response.json().catch(() => null);
      console.log(response);
      if ([200, 201].includes(response.status)) {
        $apply.complete = true;
        push("/complete");
      } else if (response.status == 204) {
        alertmsg = "お申込みのセット数が確保できませんでした。\nご理解のほど宜しくお願いいたします。";
        window.scroll(0, 0);
      } else if (response.status == 422) {
        $msg = "この申込みURLは、有効期限切れ、もしくはご使用済みのため、無効になっております。\n再度メールアドレス登録からお手続きを行っていただけますようお願いいたします。";
        push("/message");
        return;
      } else if (response.status == 424) {
        $msg = data.message;
        push("/message");
        return;
      } else if (response.status == 428) {
        $msg = "お申し込みは完了できませんでした。\n1メールアドレスにつきお申込は1回までとなります。\nお客様のメールアドレスは既にお申し込み済みです。";
        push("/message");
        return;
      } else if ([429, 504].includes(response.status)) {
        $msg = $messages.busy;
        push("/message");
        return;
      } else {
        push("/error");
        return;
      }
    } catch (err) {
      push("/error");
    } finally {
      loading = false;
    }
  }

  function modalClosed(event) {
    let agreement = event.detail.result;
    if (agreement) callApply(event);
    showModal = false;
  }
</script>

<style>
  button, .btn {
    min-width: 8.25rem;
    margin-left: .5rem;
    margin-right: .5rem;
  }
  dl {
    margin-left: .5rem;
  }
  dl dt {
    font-weight: 400;
  }
  dd {
    padding-left: .75rem;
    white-space: pre-line;
  }
  .strong {
    font-weight: 700 !important;
  }
</style>

<div class="row mb-1">
  <div class="col twelve">
    <h2>{$confirmpageheader}</h2>
  </div>
  <div class="w100">
    {#if 0 < alertmsg.length}
    <div class="alert">{alertmsg}</div>
    {/if}
    <div>
      <p>{$confirmpageexplanation}</p>
    </div>
    <div class="input-group">
    <div class="col three"><label for="email">メールアドレス</label></div>
    <div class="col nine">
      <input
        type="text"
        readonly
        bind:value={$apply.email}
        id="email"
        class="w100" />
    </div>
  </div>
  <fieldset>
    <legend>氏名</legend>
    <div class="input-group">
      <div class="col three"><label for="lastname">姓</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.lastname}
          id="lastname"
          class="w100" />
      </div>
    </div>
    <div class="input-group">
      <div class="col three"><label for="firstname">名</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.firstname}
          id="firstname"
          class="w100" />
      </div>
    </div>
    <div class="input-group">
      <div class="col three"><label for="lastnamekana">セイ</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.lastnamekana}
          id="lastnamekana"
          class="w100" />
      </div>
    </div>
    <div class="input-group">
      <div class="col three"><label for="firstnamekana">メイ</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.firstnamekana}
          id="firstnamekana"
          class="w100" />
      </div>
    </div>
  </fieldset>
  <div class="input-group">
    <div class="col three"><label for="tel">電話番号</label></div>
    <div class="col nine">
      <input
        type="text"
        readonly
        bind:value={$apply.tel}
        id="tel"
        class="w100" />
    </div>
  </div>
  <fieldset>
    <legend>住所</legend>
    <div class="input-group">
      <div class="col three"><label for="zipcode">郵便番号</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.zipcode}
          id="zipcode"
          class="w100" />
      </div>
    </div>
    <div class="input-group">
      <div class="col three"><label for="prefecture">都道府県</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.prefecture}
          class="w100"
          id="prefecture" />
      </div>
    </div>
    <div class="input-group">
      <div class="col three"><label for="city">市区町村</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.city}
          class="w100"
          placeholder=""
          id="city" />
      </div>
    </div>
    {#if $addressinput}
    <div class="input-group">
      <div class="col three"><label for="address">番地以降</label></div>
      <div class="col nine">
        <input
          type="text"
          readonly
          bind:value={$apply.address}
          class="w100"
          placeholder=""
          id="address" />
      </div>
    </div>
    {/if}
  </fieldset>
  <div class="input-group">
    <div class="col three"><label for="age">年代</label></div>
    <div class="col nine">
      <input
        type="text"
        readonly
        bind:value={$apply.age}
        class="w100"
        placeholder=""
        id="age" />
    </div>
  </div>
  <div class="input-group">
    <div class="col three"><label for="gender">性別</label></div>
    <div class="col nine">
      <input
        type="text"
        readonly
        bind:value={$apply.gender}
        class="w100"
        placeholder=""
        id="gender" />
    </div>
  </div>
  <div class="input-group">
    <div class="col three"><label for="quantity">{$quantityfield.label}</label></div>
    <div class="col nine">
      <input
        type="text"
        readonly
        bind:value={$apply.quantity}
        class="w100"
        id="quantity" />
    </div>
  </div>
  <div class="input-group">
    <div class="col three"><label for="ticketvalue">利用可能価格</label></div>
    <div class="col nine">
      <input
        type="text"
        readonly
        value={($apply.quantity * $ticketvalue).toLocaleString('ja-JP') + "円"}
        class="w100"
        id="ticketvalue" />
    </div>
  </div>
  <div class="input-group">
    <div class="col three"><label for="amount">購入価格</label></div>
    <div class="col nine">
      <input
        type="text"
        readonly
        value={($apply.quantity * $unitprice).toLocaleString('ja-JP') + "円"}
        class="w100"
        id="amount" />
    </div>
  </div>
  {#if $shopselect}
  <div class="input-group">
    <div class="col three"><label for="shop">受取店舗</label></div>
    <div class="col nine">
      <div class="row ml-1 ml-md-0">
        <div class="col">
          <p>{$apply.shopname}<br />{$apply.shopaddr}<br />{$apply.shoptel}</p>
        </div>
      </div>
    </div>
  </div>
  {/if}
  <div class="mt-1 mb-1 flex jc-center">
    <a class="btn btn-secondary" href="#/entry">戻る</a>
    <button type="button" class="btn-primary" on:click={() => (showModal = true)}>{$applybtn}</button>
  </div>
</div>
  {#if showModal}
    <Modal oktext="{$acceptbtn}" canceltext="戻る" on:close={modalClosed}>
      <h2 slot="header">{$startdatenotice.title}</h2>
      <h3>{$startdatenotice.header}</h3>
      <p class="ws-pl"><span class="danger">{$startdatenotice.alert}</span></p>
      <p class="ws-pl">{$startdatenotice.body}</p>
      <p class="ws-pl"><span class="danger">{$startdatenotice.danger}</span></p>
      <p class="ws-pl">{$startdatenotice.help}</p>
      {#if $startdatenotice.descriptions && 0 < $startdatenotice.descriptions.length}
      <dl>
      {#each $startdatenotice.descriptions as dsc}
        <dt>{dsc.term}</dt>
        <dd>{#each dsc.definition as part}<span class="{part.class ? part.class : ''}">{part.text}</span>{/each}</dd>
      {/each}
      </dl>
      {/if}
      <p class="ws-pl">{$startdatenotice.footer}</p>
    </Modal>
  {/if}
</div>
